const getEnvironment = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return 'dev'
		case 'production':
			return 'prod'
		default:
			return 'default'
	}	
}

const getPublication = (host) => {
	const regex = /([a-zA-Z]+).*/;
	const match = regex.exec(host);
	switch (match[1]) {
		case 'st':
			return 'satyagrah'
		case 'hg':
			return 'homegrown'
		case 'test':
			return 'test'
		default:
			return 'scroll'
	}	
}

export const getConfig = (host) => {
	const publication = getPublication(host);
	const environment = getEnvironment();
	const config = require(`./configs/${publication}/config.${environment}.js`);
	return config;
}

var config = null;
if (!config && typeof document !== "undefined") {
	config = getConfig(document.location.host);
}

export default config;
// export default config = () => {
//	if (document.location.host) {
//		return getConfig(document.location.host);
//	}
//};



/** WEBPACK FOOTER **
 ** ./config.js
 **/